<template>
  <div v-if="isVisible" class="war-room-achievement-banner">
    <div class="war-room-achievement-banner__achievement">
      Achievement Granted!
      <div class="war-room-achievement-banner__button">OG Sales Savage</div>
    </div>
    <div class="war-room-achievement-banner__hint">
      This means you are one of the first verified sales professionals on Bravado. This badge will show up next to your
      name when you post and cannot be achieved later.
    </div>
    <CloseIcon class="war-room-achievement-banner__close" @click="handleClose" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import CloseIcon from '@/assets/svg/close.vue.svg';

const ACHIEVEMENT_NAME = 'og_sales_savage';
const TOOLTIP_NAME = `war-room:achievement_${ACHIEVEMENT_NAME}`;

export default {
  name: 'WarRoomAchievementBanner',
  components: {
    CloseIcon,
  },
  computed: {
    isVisible() {
      if (!this.$auth.loggedIn) {
        return;
      }

      const { warRoomAchievements, tooltips } = this.$auth.user;

      return warRoomAchievements.includes(ACHIEVEMENT_NAME) && !tooltips.includes(TOOLTIP_NAME);
    },
  },
  methods: {
    ...mapActions('portfolio', ['closeTooltip']),
    handleClose() {
      this.closeTooltip(TOOLTIP_NAME);
    },
  },
};
</script>

<style scoped lang="scss">
.war-room-achievement-banner {
  display: flex;
  padding: 16px 24px;
  background: rgba(var(--black));
  border-radius: 8px;
  align-items: center;
  flex-direction: column;
  position: relative;

  @include mq('sm') {
    flex-direction: row;
  }

  &__achievement {
    width: 163px;
    margin-right: 24px;
    flex-shrink: 0;

    @include flex-center;
    @include body-semibold;

    flex-direction: column;
    color: rgba(var(--white));
  }

  &__button {
    margin-top: 8px;
    display: inline-block;
    padding: 6px 8px;
    position: relative;
    color: var(--black-a70);
    text-align: center;

    @include subhead-semibold;

    background: conic-gradient(
      from 90deg at 50% 50%,
      #eec243 0deg,
      #d3a735 90deg,
      #f3d37b 180deg,
      #ce9d2d 270deg,
      #eec243 360deg
    );
    border-radius: 8px;
    margin-bottom: 8px;

    @include mq('sm') {
      margin-bottom: 0;
    }
  }

  &__hint {
    @include subhead;

    color: rgba(var(--white));
    margin-right: 24px;
    text-align: center;

    @include mq('sm') {
      text-align: left;
    }
  }

  &__close {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    color: var(--gray-50);
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 12px;

    @include mq('sm') {
      position: relative;
      top: auto;
      right: auto;
    }

    &:hover {
      color: var(--gray-35);
    }
  }
}
</style>
